import { useContext } from 'react';
import { Formik } from 'formik';
import { Container } from '@mui/material';
import { CircleLoader } from 'components';
import { ToolTypologyForm } from './components';
import { toolTypologySchema, toolTypologyContext } from './ToolTypologyDetailsContext';

let ToolTypologys = () => {
    let service = useContext(toolTypologyContext);

    return (
        <Container>
            <Formik
                enableReinitialize={true}
                initialValues={service.toolTypology}
                validationSchema={toolTypologySchema}
                onSubmit={(values, action) => {
                    service.saveToolTypology(values);
                    action.setSubmitting(false);;
                }}
            >
                {formProps =>
                    <>
                        {service.isLoading && <CircleLoader />}
                        {service.isLoading === false && <ToolTypologyForm />}
                    </>
                }
            </Formik>
        </Container>
    )
}

export default ToolTypologys;